import React from 'react';

// Provides the mobile context indicating wheter the client is mobile or not
const MobileContext = React.createContext(false);

// eslint-disable-next-line import/prefer-default-export
export { MobileContext };
